// extracted by mini-css-extract-plugin
export default {"pageContainer":"page-container_pageContainer__ykpb6","contentContainer":"page-container_contentContainer__VGcQb"};